import { Button, Separator } from "@repo/ui";
import { Sheet, SheetContent, SheetTrigger } from "@repo/ui";
import { Leaf, Mail, MapPin, Menu, Phone } from "lucide-react";
import { useState } from "react";
import { Link, NavLink, Outlet } from "react-router-dom";

const nav = [
  { to: "/", label: "Home" },
  { to: "/accommodation", label: "Accommodation" },
  { to: "/gallery", label: "Gallery" },
  { to: "/rates", label: "Rates & Packages" },
  { to: "/activities", label: "Activities & Nearby" },
  { to: "/dining", label: "Dining/BBQ" },
  { to: "/about", label: "About" },
  { to: "/faq", label: "FAQ" },
  { to: "/policies", label: "Policies" },
  { to: "/location", label: "Location & Map" },
  { to: "/contact", label: "Contact" },
];

export default function SiteLayout() {
  const [open, setOpen] = useState(false);
  return (
    <div className="min-h-dvh flex flex-col bg-background">
      <header className="sticky top-0 z-50 bg-background/80 backdrop-blur border-b">
        <div className="max-w-6xl mx-auto px-4 py-3 flex items-center gap-4">
          <Link to="/" className="flex items-center gap-2 font-semibold text-lg">
            <Leaf className="size-6 text-primary" />
            <span>Mano Glamping</span>
          </Link>
          <nav className="hidden md:flex items-center gap-4 ml-6">
            {nav.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                className={({ isActive }) =>
                  `text-sm hover:text-primary transition-colors ${isActive ? "text-primary" : "text-foreground/80"}`
                }
              >
                {n.label}
              </NavLink>
            ))}
          </nav>
          <div className="ml-auto flex items-center gap-2">
            <span className="hidden sm:inline text-sm text-muted-foreground">@manoglamping</span>
            <Button asChild className="bg-primary text-primary-foreground hover:opacity-90">
              <Link to="/booking">Book Now</Link>
            </Button>
            <Sheet open={open} onOpenChange={setOpen}>
              <SheetTrigger asChild>
                <Button variant="outline" size="icon" className="md:hidden">
                  <Menu className="size-5" />
                </Button>
              </SheetTrigger>
              <SheetContent side="right" className="w-80">
                <div className="grid gap-2 mt-8">
                  {nav.map((n) => (
                    <Link
                      key={n.to}
                      to={n.to}
                      onClick={() => setOpen(false)}
                      className="py-2 text-foreground/90 hover:text-primary"
                    >
                      {n.label}
                    </Link>
                  ))}
                </div>
                <Separator className="my-4" />
                <Button asChild className="w-full">
                  <Link to="/booking" onClick={() => setOpen(false)}>
                    Book Now
                  </Link>
                </Button>
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </header>
      <main className="flex-1">
        <Outlet />
      </main>
      <footer className="border-t mt-10">
        <div className="max-w-6xl mx-auto px-4 py-10 grid gap-8 md:grid-cols-3">
          <div className="space-y-2">
            <div className="flex items-center gap-2 font-semibold text-lg">
              <Leaf className="size-6 text-primary" />
              <span>Mano Glamping</span>
            </div>
            <p className="text-sm text-muted-foreground">Suan Pueng, Ratchaburi, Thailand</p>
            <p className="text-sm text-muted-foreground">@manoglamping</p>
          </div>
          <div className="grid grid-cols-2 gap-2 text-sm">
            {nav.slice(0, 8).map((n) => (
              <Link key={n.to} to={n.to} className="text-foreground/80 hover:text-primary">
                {n.label}
              </Link>
            ))}
          </div>
          <div className="space-y-2 text-sm text-muted-foreground">
            <div className="flex items-center gap-2">
              <MapPin className="size-4" /> Suan Pueng, Ratchaburi
            </div>
            <div className="flex items-center gap-2">
              <Phone className="size-4" /> +66 ••••••••
            </div>
            <div className="flex items-center gap-2">
              <Mail className="size-4" /> hello@manoglamping.com
            </div>
          </div>
        </div>
        <div className="text-center text-xs text-muted-foreground pb-8">
          © {new Date().getFullYear()} Mano Glamping
        </div>
      </footer>
    </div>
  );
}
